module.exports = __webpack_public_path__ + "img/girl.2fd8ed5e.png";